import tailwindConfig from "../../../../tailwind.config";

export const chartColors: {
    default: string;
    negative: string;
    highlighted: string;
}[] = Object.values(tailwindConfig.theme.extend.colors.chart);

export * from "./Chart.types";
